module.exports = __webpack_public_path__ + "static/media/london_4.7ad6a7ae.png";